import type { SxProps, Theme } from '@mui/material'

export const dialogTitleBarSx: SxProps<Theme> = (theme) => ({
  pt: 3,
  pb: 3,
  px: 3,
  borderBottom:
    theme.palette.mode === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.08)'
      : '1px solid rgba(62, 39, 35, 0.08)',
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(62, 39, 35, 0.02)',
})

export const dialogTitleRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  mb: 3,
}

export const dialogTitleContentSx: SxProps<Theme> = {
  flex: 1,
  pr: 2,
}

export const dialogBadgeWrapperSx: SxProps<Theme> = {
  mb: 2,
}

export const dialogTitleTextSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '1.25rem',
  mb: 1,
}

export const dialogBreadcrumbSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.5,
}

export const dialogWindowControlsSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 3,
}

export const dialogPassiveIconButtonSx: SxProps<Theme> = {
  color: 'text.secondary',
  cursor: 'default',
  '&:hover': { backgroundColor: 'transparent' },
}

export const dialogCloseIconButtonSx = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.error.main,
  width: 32,
  height: 32,
  cursor: 'default',
  '&:hover': { backgroundColor: 'transparent' },
})

export const dialogControlsRowSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
}

export const dialogControlsRowLeftSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
}

export const dialogControlsRowCenterSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
}

export const dialogControlsRowRightSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
}

export const dialogPointerEventsNoneSx: SxProps<Theme> = {
  pointerEvents: 'none',
}
